import { useMediaQuery, useTheme } from '@material-ui/core'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useStyles from './Content.styled'

export const useContent = props => {
	const {
		mobileImage,
		desktopImage,
		contentWidth,
		textShadow,
		extraShortcuts,
		direction,
		mobileImagePosition,

		text,
		textKey,
		textConfig,
		textEditable,

		buttonText,
		buttonAction,
		buttonLink,
		buttonTextEditable,
		buttonTextConfig,
		buttonTextKey,

		onTextClick,
		onButtonClick,
		onImageClick,
		onMobileImageClick,
		onTextChange,
		onButtonTextChange,
	} = props

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const isMobileImage = isMobile && !!mobileImage?.image

	const image = isMobileImage ? mobileImage : desktopImage

	const isBackground = mobileImagePosition === PageMetaData.IMAGE_POSITION.BACKGROUND

	const isImageExist = !!image?.image

	const classes = useStyles({ ...props, isMobile })

	return [
		{
			classes,
			withBgImage: isImageExist && (!isMobile || isBackground),
			withMobileImage: isMobile && !isBackground && isImageExist,
			image,
			contentWidth,
			isMobile,
			textShadow,
			extraShortcuts,
			direction,

			text,
			textKey,
			textConfig,
			textEditable,

			buttonText,
			buttonAction,
			buttonLink,
			buttonTextEditable,
			buttonTextConfig,
			buttonTextKey,
		},
		{
			handleTextClick: onTextClick,
			handleButtonClick: onButtonClick,
			handleImageClick: isMobileImage ? onMobileImageClick : onImageClick,
			handleTextChange: onTextChange,
			handleButtonTextChange: onButtonTextChange,
		},
	]
}
